export default __webpack_public_path__ + "static/wen-testimony-2e07b7f44faeec66c01a45397f7c856d.png";